var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0928 12.3667L28.5278 1.9307C28.823 1.63475 29.1737 1.39995 29.5598 1.23974C29.9459 1.07954 30.3598 0.99707 30.7778 0.99707C31.1958 0.99707 31.6097 1.07954 31.9958 1.23974C32.3819 1.39995 32.7326 1.63475 33.0278 1.9307L33.0738 1.9767C33.6697 2.57268 34.0044 3.38094 34.0044 4.2237C34.0044 5.06647 33.6697 5.87473 33.0738 6.4707L19.4838 20.0567C18.8798 20.6601 18.061 20.999 17.2073 20.999C16.3535 20.999 15.5347 20.6601 14.9308 20.0567L1.34378 6.4707C0.747899 5.87473 0.413147 5.06647 0.413147 4.2237C0.413147 3.38094 0.747899 2.57268 1.34378 1.9767L1.38978 1.9307C1.68474 1.63542 2.03501 1.40116 2.42057 1.24134C2.80613 1.08151 3.21941 0.999245 3.63678 0.999245C4.05415 0.999245 4.46743 1.08151 4.85298 1.24134C5.23854 1.40116 5.58881 1.63542 5.88378 1.9307L16.3208 12.3667C16.4371 12.4832 16.5752 12.5756 16.7272 12.6386C16.8792 12.7017 17.0422 12.7341 17.2068 12.7341C17.3714 12.7341 17.5343 12.7017 17.6864 12.6386C17.8384 12.5756 17.9765 12.4832 18.0928 12.3667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.e7e6fb72.svg";
export { ForwardRef as ReactComponent };